import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { styles } from './SetupPDFHeader.styles';
import { ISetupPdfMessages } from '../../../../types/setupPDFTypes';

export enum ExportType {
  STORY = 'Story',
  PUBLICATION = 'Publication',
  FOLDER = 'Folder',
  SECTION = 'Section',
}
type SetupPDFHeaderProps = {
  exportType: ExportType;
  messages: ISetupPdfMessages;
  subtitle?: string;
  title: string;
  onExport: () => void;
  onSaveAndExit: () => void;
  onDiscard: () => void;
  isApplyingStyles: boolean;
  isExportDisabled: boolean;
};

export const SetupPDFHeader = ({
  exportType,
  title,
  subtitle,
  messages,
  onExport,
  onSaveAndExit,
  onDiscard,
  isApplyingStyles,
  isExportDisabled
}: SetupPDFHeaderProps) => {
  return (
    <Box sx={styles.headerContainer}>
      <Box data-test="publicationSetupPDFHeader" sx={styles.headerRow}>
        <Box sx={styles.titleContainer}>
          <Typography variant="h1">{title}</Typography>
        </Box>
        <Box sx={styles.headerActions}>
          <Button data-test="discardButton" color="secondary" onClick={onDiscard}>
            {messages.discard}
          </Button>
          {exportType !== ExportType.STORY ? <Button data-test="saveAndExitButton" color="secondary" variant="outlined" onClick={onSaveAndExit}>
            {messages.saveAndExit}
          </Button> : null}
          <Button
            data-test="exportButton"
            variant="contained"
            color="primary"
            onClick={onExport}
            disabled={isApplyingStyles || isExportDisabled}
          >
            {messages.export}
          </Button>
        </Box>
      </Box>
      {exportType === ExportType.PUBLICATION || exportType === ExportType.STORY ?
        (<Box sx={styles.subtitleContainer}>
          <Typography variant="bodyDefault" sx={styles.subtitleLabel}>{exportType}:</Typography>
          <Typography variant="bodyDefault" sx={styles.subtitle}>{subtitle}</Typography>
        </Box>) : null
      }
    </Box>
  );
};
